import { uuidv4 } from '@core/helpers/uuidv4'
import {
  EnumFunnelTrackingCookies,
  getCookieWithFallback,
  setCookieWithFallback,
} from '@core/tracking/funnelTracking'
import { getGuestIdOverride } from '@core/tracking/guestId'

/**
 *
 */
export function persistGuestId() {
  const guestId =
    getGuestIdOverride() ||
    getCookieWithFallback(EnumFunnelTrackingCookies.FW_GUEST_ID)?.value ||
    uuidv4()

  if (guestId) {
    setCookieWithFallback(EnumFunnelTrackingCookies.FW_GUEST_ID, guestId)
  }
}
